import axios from 'axios';

export const eponaProgressApi = (subUri: string, postData?: Record<string, any>) =>
  axios({
    headers: {
      'authorization-dex': `Bearer ${localStorage.getItem('token')?.replace(/"/g, '')}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
    url: `${process.env.VUE_APP_PEGASUS_EPONA_PROGRESS_API}${subUri}`,
    method: postData ? 'POST' : 'GET',
    data: postData,
  });
